module.exports = __webpack_public_path__ + "static/AvenirNext-BoldItalic-330e8e4d42416795c686b2b71c14c1f6.woff2";